import React from 'react';

import { useFormContext, Controller } from 'react-hook-form';

type Props = {
  name: string;
};

const FormInput = ({ name }: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      as={<input type='hidden'/>}
    />
  );
};

export default FormInput;
